import './register-router-hooks'
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import App from './App.vue'
import router from './router'

import './shims-jquery'
import 'popper.js'
import 'bootstrap'
import 'simplelightbox'

import Selectize from 'vue2-selectize'

Vue.config.productionTip = false
Vue.component('selectize', Selectize)
Vue.use(VueCookies)

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
